// extracted by mini-css-extract-plugin
export const listItem = "item-module--listItem--10235";
export const listItemSpecial = "item-module--listItemSpecial--2kfH7";
export const hiddenLink = "item-module--hiddenLink--3HNEp";
export const icon = "item-module--icon--3zQFZ";
export const illustration = "item-module--illustration--3mDmP";
export const title = "item-module--title--m3vl6";
export const caption = "item-module--caption--2CmFG";
export const header = "item-module--header--3vd_7";
export const headerRight = "item-module--headerRight--mC8ix";
export const headTag = "item-module--headTag--TEGHh";
export const tags = "item-module--tags--DyIZ8";
export const yearCount = "item-module--yearCount--2yQv9";
export const yearText = "item-module--yearText--1mZNT";